import Hero from '@/components/Hero';
import TripleSection from '@/components/TripleSection';
import HowItWorks from '@/components/HowItWorks';
import PlatformsSection from '@/components/PlatformsSection';
import CTABanner from '@/components/CTABanner';

export default function Home() {
  return (
    <>
      <Hero />

      <TripleSection
        id="what"
        label="What it is"
        title="Legal services, restructured for the AI era."
        lead="Traditional firms bill by the hour because the work was manual. AVOWAL automates the manual layer, which makes flat-fee, attorney-backed representation viable for matters that used to be either prohibitively expensive or impossible to staff."
        cards={[
          { num: '/ 01', title: 'Limited-scope representation', body: 'You hire an attorney for a specific task — a motion, a hearing, a contract review — not the whole matter. Defined, capped, court-approved where required. We make it the default, not the exception.' },
          { num: '/ 02', title: 'AI-managed workflow',         body: 'ELARIA handles intake, document assembly, deadline tracking, citation verification, and communications. Your attorney spends their time on judgment, not paperwork. The price reflects it.' },
          { num: '/ 03', title: 'White-label by design', body: "We don't employ lawyers, and we don't stand between you and yours. Clients work in their attorney's own portal — the firm's name, the firm's domain, an assistant the attorney names and configures. The attorney runs the practice; we run the operations layer." },
        ]}
      />

      <HowItWorks />
      <PlatformsSection />

      <TripleSection
        id="elaria"
        label="The agent"
        title="ELARIA — the operations layer."
        lead="ELARIA is the AI agent that runs inside AVOWAL. Patent-pending architecture, built from the ground up for legal work: citation verification, hallucination detection, audit-trail evidence chains, and deep integration with court e-filing systems."
        cards={[
          { num: '/ DOES',     title: 'Operations',    body: 'Intake, document drafting, citation verification, deadline tracking, evidence organization, communications, filing prep, audit trails. The mechanical layer of practice.' },
          { num: '/ DOES NOT', title: 'Legal advice',  body: "ELARIA does not advise on strategy, predict outcomes, or substitute for an attorney. Every judgment call is escalated to the attorney. Every output is reviewed before filing." },
          { num: '/ NEVER',    title: 'Fabricates',    body: 'Every citation is verified against primary sources before it leaves the system. Every fact is traceable to its document. Hallucination is treated as a defect, not an acceptable failure mode.' },
        ]}
      />

      <TripleSection
        id="trust"
        label="Trust by construction"
        title="Built so you don't have to take our word for it."
        cards={[
          { num: '/ ATTORNEYS', title: 'Independent, licensed, accountable', body: 'Every attorney on the platform is independently licensed and personally accountable for the work they sign. AVOWAL never holds itself out as legal counsel.' },
          { num: '/ ETHICS',    title: 'UPL-safe by design',                  body: 'Workflows are structured around the unauthorized-practice-of-law rules of each jurisdiction. ELARIA executes; attorneys advise. The line is clear and enforced in software.' },
          { num: '/ PROOF',     title: 'Cryptographically verifiable',        body: 'Every filing AVOWAL prepares carries a signed manifest of sources, citations, and the chain of edits. Verifiable by court, opposing counsel, or auditor.' },
        ]}
      />

      <CTABanner />
    </>
  );
}
